import { Link } from "react-router-dom";
import { showcase } from "@/mocks/home";
import { track } from "@/lib/analytics";

export default function Showcase() {
  return (
    <section id="product" className="relative bg-background-50 py-16 md:py-20 px-4 md:px-8 overflow-hidden">
      <div className="w-full mb-10" aria-hidden>
        <img
          src="https://joble.app/images/coil.svg"
          alt=""
          className="w-full h-auto object-cover opacity-70"
        />
      </div>

      <div className="max-w-6xl mx-auto space-y-20 md:space-y-24">
        {showcase.map((item, index) => (
          <div key={item.title}>
            <h2 className="reveal font-heading text-3xl sm:text-4xl md:text-5xl font-medium text-foreground-900 leading-tight tracking-tight mb-8 max-w-2xl">
              {item.heading}
            </h2>

            <div className="reveal rounded-2xl border border-background-300/30 bg-background-950 p-6 md:p-10">
              <div
                className={`flex flex-col lg:flex-row items-center gap-8 lg:gap-12 ${
                  index % 2 === 1 ? "lg:flex-row-reverse" : ""
                }`}
              >
                <div className="flex-1 w-full max-w-md p-2 md:p-4">
                  <p className="text-sm font-medium text-accent-300 mb-3">{item.eyebrow}</p>
                  <h3 className="text-2xl md:text-3xl font-bold text-foreground-50 mb-4 leading-tight">
                    {item.title}
                  </h3>
                  <p className="text-sm md:text-base text-foreground-200 mb-8 leading-relaxed">
                    {item.description}
                  </p>
                  <a
                    href="https://app.joble.app/auth/create-account?free=true"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() =>
                      track("try_joble_clicked", { location: `showcase_${item.eyebrow}` })
                    }
                    className="group inline-flex items-center gap-2 rounded-lg bg-primary-500 text-foreground-950 text-sm font-semibold pl-5 pr-1.5 py-1.5 hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
                  >
                    Try Joble Now
                    <span className="w-7 h-7 rounded-full bg-background-950 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
                      <i className="ri-arrow-right-line text-foreground-950 text-sm" aria-hidden></i>
                    </span>
                  </a>
                </div>

                <div className="flex-1 w-full">
                  <div className="overflow-hidden rounded-xl">
                    <img
                      src={item.image}
                      alt={item.imageAlt}
                      className="w-full h-auto object-cover"
                      title={item.title}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="w-full mt-16" aria-hidden>
        <img
          src="https://joble.app/images/coil.svg"
          alt=""
          className="w-full h-auto object-cover opacity-70"
        />
      </div>

      <div className="relative max-w-6xl mx-auto mt-12 text-center">
        <Link
          to="/products"
          className="group inline-flex items-center justify-center gap-3 rounded-full border border-background-300/60 text-foreground-900 font-semibold text-base px-8 py-4 hover:bg-background-100/70 transition-colors cursor-pointer whitespace-nowrap"
        >
          See all Joble products
          <span className="w-7 h-7 rounded-full bg-background-950 flex items-center justify-center group-hover:translate-x-0.5 transition-transform">
            <i className="ri-arrow-right-line text-foreground-950" aria-hidden></i>
          </span>
        </Link>
      </div>
    </section>
  );
}